import { ContentContainer } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { SubClient } from '../../../types/subClient';
import { WebServiceFiltersBar } from './WebServiceFiltersBar';
import { WebServiceList } from './WebServiceList';

type Props = {
  subClient: SubClient;
};

export function WebServicesTab({ subClient }: Readonly<Props>) {
  const [reloadPage, setReloadPage] = useState(false);

  return (
    <ContentContainer>
      <WebServiceFiltersBar
        subClientId={subClient._id}
        onReloadPage={() => setReloadPage(!reloadPage)}
      />
      <WebServiceList
        subClientId={subClient._id}
        reloadPage={reloadPage}
      />
    </ContentContainer>
  );
}
